
import { makeAutoObservable } from 'mobx';
import { Storage } from '@xt/xtbase';
import { get_symbol } from '@/api/v4/market';


export default class Market {

  loading:boolean = false;

  market :string = "btc_usdt";
  marketConfig: {} = {};
  marketConfigMd5: string = "";

  tickers:[] = [];
  

  constructor() {
    makeAutoObservable(this);
  }

  init(appState){
    const marketConfig = Storage.get("marketConfig") || {};
    this.marketConfig = marketConfig.list || {};
    for(var key in this.marketConfig)
    {
      if(this.marketConfig[key].buyPoint < 0 )
        this.marketConfig[key].buyPoint = 0;
      if(this.marketConfig[key].quantityPrecision < 0 )
        this.marketConfig[key].quantityPrecision = 0;
    }
    this.marketConfigMd5 = marketConfig.md5 || "";
    this.getMarketConfig();
  }

  async getMarketConfig() {
    if(this.loading)
      return;
    this.loading = true;

    const data: any = await get_symbol({
      params: {
        version: this.marketConfigMd5,
      }
    }).finally(() => {
      this.loading = false;
    });

    if (data.symbols && data.version !== this.marketConfigMd5) {
      console.log("【getSymbol update】", data);
      const marketConfig = {};
      data.symbols.map((obj) => {
        marketConfig[obj.symbol] = {
          ...obj,
          //兼容处理
          buyPoint: obj.pricePrecision > 0 ? obj.pricePrecision : 0,
          sellPoint: obj.quantityPrecision > 0 ? obj.quantityPrecision : 0,
        };
      });
      this.marketConfig = marketConfig;
      this.marketConfigMd5 = data.version;
      Storage.set("marketConfig", {
        list: marketConfig,
        md5: data.version,
      });
    }
  }
  
  isEtfMarket(symbol) {
    const config = this.marketConfig[symbol];
    return config && config.plates.includes(145);
  }
}
